import React, { useEffect, useState } from "react";
import {
  Form,
  Input,
  Button,
  DatePicker,
  Select,
  Row,
  Col,
  InputNumber,
  Divider,
  Tabs,
  Card,
  Table,
  Radio,
  Checkbox,
  Image,
  Tag,
  Space,
  Tooltip,
  Modal,
  message,
  Upload,
  notification,
  Popconfirm,
} from "antd";

import { ParticipantsIpmService } from "../Services/ParticipantsIpmService";
import { PaysService } from "../Services/PaysService";
import CategoriesPro from "./CategoriePro";
import Region from "./Region";
import avatar from "./Image/avatar.jpg";
import { PrestationsService } from "../Services/PrestationsService";
import { AdherentsService } from "../Services/AdherentsService";
import { Link, Navigate, useNavigate } from "react-router-dom";

import {
  DeleteFilled, EditOutlined, PlusOutlined, UserOutlined, IdcardOutlined,
  EnvironmentOutlined, BankOutlined, FileTextOutlined, TeamOutlined,
  SaveOutlined, CloseOutlined, CameraOutlined, CheckCircleOutlined,
  ClockCircleOutlined, StopOutlined, CloseCircleOutlined
} from "@ant-design/icons";
import dayjs from "dayjs";
import { FamilleService } from "../Services/FamilleService";
import { api_DisplayName } from "../Services/Constantes";
import api from "../Services/AxiosInstance";
import { QRCode } from "antd/lib";
import DepartementSelect from "./DepartementSelect";
import moment from "moment";
import { use } from "react";
import "../Pages/CSS/Traitement.css";

const typePieceChampsMapping = {
  p0: "",
  p1: "CIN",
  p2: "Passport",
  p3: "Carte de Séjour",
  p4: "Permis de Conduire",
  p5: "Autre",
};
const { Option } = Select;
const { confirm } = Modal;
const Formulaire = ({
  onSubmit,
  initialValues,
  mode,
  matripart,
  familleData = [],

}) => {
  const [form] = Form.useForm();
  const navigate = useNavigate();
  const [formMain] = Form.useForm(); // Formulaire principal
  const [formModal] = Form.useForm(); // Formulaire du modal
  const suspensionBenefValue = Form.useWatch("suspension_benef", formModal);
  const pcTemporaireContratValue = Form.useWatch("pc_temporaire", formMain);
  const dateDebCouvertureContratValue = Form.useWatch("date_deb_couverture", formMain);
  const nbMoisCouvertContratValue = Form.useWatch("nb_mois_couvert", formMain);
  const motifSuspensionValue = Form.useWatch("motif_suspension", formMain);
  const [societes, setSocietes] = useState([]);
  const [pays, setPays] = useState([]);
  const [selectedTypePiece, setSelectedTypePiece] = useState("p0");
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [benefs, setBenefs] = useState([]);
  const [editingMember, setEditingMember] = useState(null);
  const [selectedBenefType, setSelectedBenefType] = useState(null);
  const [famille, setFamilleData] = useState([]); // Initialiser l'état vide
  const [fileList, setFileList] = useState([]);
  const [modalVisible, setModalVisible] = useState(false);
  const [modalVisibleBenef, setModalVisibleBenef] = useState(false);
  const [img, setImg] = useState();
  const [imgBenef, setImgBenef] = useState();
  const [basculerVers, setBasculerVers] = useState(null);
  const [suspensionPart, setSuspensionPart] = useState(null);
  const [loading, setLoading] = useState(false);
  const [typeDocuments, setTypeDocuments] = useState([]);


  const participantsIpmService = new ParticipantsIpmService();
  const familleService = new FamilleService();
  const prestationService = new PrestationsService();
  const paysService = new PaysService();
  const adherentsService = new AdherentsService();

  const handleSuspensionChange = (e) => {
    setSuspensionPart(e.target.value);
    formMain.setFieldsValue({ motif_suspension: undefined });
  };

  const defaultAvatar = avatar;

  const userId = localStorage.getItem('login');

  /*   useEffect(() => {
    
    setFamilleData(familleData);
  }, [familleData]); */


  useEffect(() => {
    const fetchData = async () => {
      try {
        const societesData = await adherentsService.getAllAdherents();

        // Filtrer les adhérents pour exclure ceux qui ont suspension_adht à true
        const filteredAdherents = societesData.filter(
          (adherent) => !adherent.suspension_adht
        );
        setSocietes(filteredAdherents);
        const paysData = await paysService.getAllPays();
        setPays(paysData);

        const prestationData = await prestationService.getAllPrestation();
      } catch (error) {
        console.error("Erreur lors de la récupération des données :", error);
      }
    };

    fetchData();
  }, []);

  useEffect(() => {
    if (initialValues) {
      formMain.setFieldsValue({
        ...initialValues,

        etatcont: initialValues.etatcont || "OU",
      });
      setSelectedTypePiece(initialValues.type_piece || "p0");
      // Initialiser le statut du participant pour la mise en évidence
      if (initialValues.suspension_part) {
        setSuspensionPart(initialValues.suspension_part);
      }
    }
  }, [initialValues, formMain]);

  useEffect(() => {
    if (matripart) {
      fetchDocAutorises(matripart);
    }
  }, [matripart]);

  const fetchDocAutorises = async (numcont) => {
    try {
      const data = await participantsIpmService.getAllDocAutorises(numcont);
      setTypeDocuments(data);

    } catch (error) {
      console.error('Erreur lors de la récupération des données :', error);
    }
  };


  const handleSubmit = (values) => {
    if (!values.etatcont) {
      values.etatcont = "OU"; // Valeur par défaut si non modifiée
    }

    onSubmit(values).then((response) => {
      if (response) {
        // Vérification du succès (nouveau format de réponse)
        if (response.success) {
          notification.success({
            message: "Succès",
            description: response.message || "Participant ajouté avec succès",
          });
          formMain.resetFields(); // Réinitialiser le formulaire après ajout
        } else {
          // Gestion des différents types d'erreurs
          if (response.error === "DUPLICATE_KEY") {
            notification.error({
              message: "Erreur",
              description: response.message || "Le participant existe déjà dans la base de données.",
            });
          } else if (response.error === "DATA_INTEGRITY_VIOLATION") {
            notification.error({
              message: "Erreur d'intégrité",
              description: response.message || "Violation des règles de données.",
            });
          } else {
            notification.error({
              message: "Erreur",
              description: response.message || "Une erreur s'est produite lors de l'ajout du participant.",
            });
          }
        }
      }
    }).catch((error) => {
      // Gestion des erreurs de réseau ou autres exceptions
      notification.error({
        message: "Erreur",
        description: "Erreur de connexion ou problème technique.",
      });
      console.error("Erreur lors de l'appel API:", error);
    });
  };

  const handleFailedSubmit = ({ errorFields }) => {
    if (errorFields.length > 0) {
      const fieldNames = errorFields
        .map((field) => field.name?.[0])
        .join(", ");

      notification.error({
        message: "Champs requis manquants",
        description: `Veuillez renseigner les champs suivants : ${fieldNames}`,
      });
    }
  };

  const handleTypePieceChange = (value) => {
    setSelectedTypePiece(value);
    formMain.resetFields([typePieceChampsMapping[value]]);
  };

  const handleEtatContChange = (value) => {
    formMain.setFieldsValue({ etatcont: value });
  };

  const handleUploadChange = ({ fileList }) => {
    setFileList(fileList.slice(-1));
  };

  const handleUpload = async () => {
    setLoading(true);
    if (fileList.length === 0) {
      message.error("Veuillez sélectionner une image.");
      return;
    }

    const formData = new FormData();
    formData.append("file", fileList[0].originFileObj);

    try {
      await api.post(`Participant/addPhoto/${matripart}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      }); // Appel à l'API pour télécharger l'image
      message.success("Photo mise à jour avec succès!");
      setModalVisible(false);
      setFileList([]);
      fetchImg(); // Recharger l'image après le téléchargement
    } catch (error) {
      message.error("Erreur lors du téléchargement de la photo.");
    } finally {
      setLoading(false); // Arrête l'indicateur de chargement après l'upload
    }
  };

  const handleUploadBenefChange = ({ fileList }) => {
    setFileList(fileList.slice(-1));
  };
  const handleUploadBenef = async () => {
    if (fileList.length === 0) {
      message.error("Veuillez sélectionner une image.");
      return;
    }

    const matribenef = formModal.getFieldValue("matribenef"); // Récupérer le matribenef depuis le champ du formulaire

    if (!matribenef) {
      message.error("Le matricule du bénéficiaire est manquant.");
      return;
    }

    const formData = new FormData();
    formData.append("file", fileList[0].originFileObj);

    try {
      await api.post(`Participant/addPhoto/${matribenef}`, formData, {
        headers: {
          "Content-Type": "multipart/form-data",
        },
      });

      message.success("Photo mise à jour avec succès!");
      setModalVisibleBenef(false); // Assurez-vous de fermer le bon modal
      setFileList([]);
      fetchImageBeneficiare(matribenef); // Recharger l'image après le téléchargement en passant le matribenef
    } catch (error) {
      message.error("Erreur lors du téléchargement de la photo.");
    }
  };

  const openModalBenef = () => {
    setModalVisibleBenef(true);
  };

  const closeModalBenef = () => {
    setModalVisibleBenef(false);
    setFileList([]);
  };

  const openModal = () => {
    setModalVisible(true);
  };

  const closeModal = () => {
    setModalVisible(false);
    setFileList([]);
  };

  const handleDelete = async (record) => {
    try {
      // Suppression du bénéficiaire
      await familleService.deleteBenefs(record.matribenef);
      message.success("Bénéficiaire supprimé avec succès");

      // Récupérer les données mises à jour de la famille après suppression
      const updatedFamilleData = await familleService.getAllBeneciaire(
        matripart
      );

      // Charger les images pour chaque bénéficiaire restant
      const updatedFamilleDataWithImages = await Promise.all(
        updatedFamilleData.map(async (benef) => {
          const photoUrl = await fetchImageBeneficiare(benef.matribenef);
          return { ...benef, photoUrl };
        })
      );

      // Mettre à jour les données dans l'état, y compris les photos
      setFamilleData(updatedFamilleDataWithImages);
    } catch (error) {
      console.error("Erreur lors de la suppression du bénéficiaire :", error);
      message.error("Erreur lors de la suppression du bénéficiaire");
    }
  };

  const fetchImg = async () => {
    console.log(matripart);

    try {
      const image = await participantsIpmService.fetchImage(matripart);
      if (image) {
        setImg(image);
      } else {
        console.error("Image non trouvée ou matripart incorrect");
      }
    } catch (error) {
      console.error("Erreur lors de la récupération des données :", error);
    }
  };

  useEffect(() => {
    if (matripart) {
      fetchImg();
    } else {
      // console.error("Matripart est undefined");
    }
  }, [matripart]);

  const fetchImageBeneficiare = async (matribenef) => {
    if (!matribenef) {
      console.error("Matribenef manquant");
      return null;
    }

    try {
      const res = await participantsIpmService.fetchImageBenef(matribenef);
      setImgBenef(res);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération de la photo du bénéficiaire :",
        error
      );
      return null;
    }
  };

  useEffect(() => {
    if (editingMember) {
      fetchImageBeneficiare();
    }
  }, [editingMember]);

  useEffect(() => {
    // Fonction pour charger les images pour chaque bénéficiaire
    const loadImagesForBeneficiaries = async () => {
      const familleDataWithImages = await Promise.all(
        familleData.map(async (benef) => {
          // Si la photo est déjà chargée, ne la rechargez pas
          if (benef.photoUrl) {
            return benef;
          }
          const photoUrl = await participantsIpmService.fetchImageBenef(
            benef.matribenef
          );
          return { ...benef, photoUrl };
        })
      );
      setFamilleData(familleDataWithImages);
    };

    // Ne chargez les images que si le tableau familleData n'est pas vide
    if (familleData.length > 0) {
      loadImagesForBeneficiaries();
    }
  }, [familleData]);

  // Dès que "Prise en Charge Temporaire" est cochée, initialise la date de début à aujourd'hui
  // et le nombre de mois couvert à 1, si ces champs ne sont pas déjà renseignés
  // (onglet "Infos Contrat IPM")
  useEffect(() => {
    if (pcTemporaireContratValue && !dateDebCouvertureContratValue) {
      formMain.setFieldsValue({ date_deb_couverture: dayjs() });
    }
  }, [pcTemporaireContratValue, dateDebCouvertureContratValue, formMain]);

  useEffect(() => {
    if (pcTemporaireContratValue && !nbMoisCouvertContratValue) {
      formMain.setFieldsValue({ nb_mois_couvert: 1 });
    }
  }, [pcTemporaireContratValue, nbMoisCouvertContratValue, formMain]);

  // Calcule automatiquement la date de fin de couverture (date début + nombre de mois couverts)
  // pour l'onglet "Infos Contrat IPM" (formulaire principal)
  useEffect(() => {
    if (!pcTemporaireContratValue || !dateDebCouvertureContratValue || !nbMoisCouvertContratValue) {
      return;
    }
    const dateDeb = dayjs(dateDebCouvertureContratValue);
    if (!dateDeb.isValid()) {
      return;
    }
    const dateFin = dateDeb.add(Number(nbMoisCouvertContratValue), "month");
    formMain.setFieldsValue({ date_fin_couverture: dateFin });
  }, [pcTemporaireContratValue, dateDebCouvertureContratValue, nbMoisCouvertContratValue, formMain]);

  const handleSocieteChange = (value) => {
    setBasculerVers(value); // Met à jour l'état avec la nouvelle valeur sélectionnée

    confirm({
      title: "Confirmer le basculement",
      content: "Êtes-vous sûr de vouloir changer la société ?",
      okText: "Oui",
      cancelText: "Non",
      /// okButtonProps: { disabled: !mode },
      onOk: async () => {
        try {
          const payload = {
            codesoc: value,
            matricule: formMain.getFieldValue("matricule"),
            numcont: formMain.getFieldValue("numcont"),
            categprof: formMain.getFieldValue("categprof"),
            etat: formMain.getFieldValue("etat"),
            suspension_part: formMain.getFieldValue("suspension_part"),
          };

          const response = await participantsIpmService.putcodesoc(payload);

          if (response.Toggled === "SUCCESS") {
            message.success("Basculement effectué avec succès !");
            setBasculerVers(null); // Réinitialise le Select après succès
            navigate(`/participants`);
          } else if (response.Toggled === "DUPLICATE_PART") {
            message.error("Participant existe déjà dans cette société !");
            setBasculerVers(null); // Réinitialise la sélection en cas de duplication
          } else {
            message.error("Échec de la mise à jour de la société.");
            setBasculerVers(null); // Réinitialise la sélection en cas d'échec
          }
        } catch (error) {
          message.error("Erreur lors de la mise à jour de la société.");
          setBasculerVers(null); // Réinitialise la sélection en cas d'erreur
        }
      },
      onCancel() {
        message.info("Mise à jour annulée.");
        setBasculerVers(null); // Réinitialise la sélection si annulé
      },
    });
  };

  const columnsDoc = [
    {
      title: 'Code',
      dataIndex: 'typedoc',
      key: 'typedoc',
    },
    {
      title: 'Type Document',
      dataIndex: 'libdoc',
      key: 'libdoc',
    },
    {
      title: 'Autorisé',
      dataIndex: 'actif',
      key: 'actif',
      align: 'center',
      render: (actif, record) => (
        <Checkbox
          checked={actif}
          onChange={(e) => {
            const updatedData = typeDocuments.map(item =>
              item.typedoc === record.typedoc ? { ...item, actif: e.target.checked } : item
            );
            setTypeDocuments(updatedData);
          }}
        />
      ),
    },
  ];


  const columns = [
    {
      title: "Photo",
      dataIndex: "photo",
      key: "photo",
      align: "center",
      render: (text, record) => (
        <Image
          src={record.photoUrl || defaultAvatar}
          onError={(e) => {
            e.target.src = defaultAvatar; // Remplace par defaultAvatar si l'image échoue
          }}
          alt="Photo"
          width={50}
          height={50}
          style={{
            objectFit: "cover",
            borderRadius: "50%",
          }}
        />
      ),
    },
    {
      title: "Matricule",
      dataIndex: "matribenef",
      key: "matribenef",
      align: "center",
    },
    {
      title: "Type Benef",
      dataIndex: "codebenef",
      key: "codebenef",
      render: (text) => {
        let typeBenefLabel = "";

        switch (text) {
          case "2":
            typeBenefLabel = "Epouse";
            break;
          case "3":
            typeBenefLabel = "Enfant";
            break;
          case "4":
            typeBenefLabel = "Epoux";
            break;
          case "5":
            typeBenefLabel = "Ascendant";
            break;
          case "6":
            typeBenefLabel = "Autre";
            break;
          default:
            typeBenefLabel = "Inconnu";
        }

        return <span>{typeBenefLabel}</span>;
      },
    },
    { title: "Prénom(s)", dataIndex: "prenoms", key: "prenoms" },
    { title: "Nom", dataIndex: "nom", key: "nom" },
    { title: "Adresse", dataIndex: "adresse", key: "adresse" },
    {
      title: "Lieu naissance",
      dataIndex: "lieunaiss",
      key: "lieunaiss",
    },
    { title: "Age", dataIndex: "ageb", key: "ageb", align: "center" },
    { title: "Sexe", dataIndex: "sexe", key: "sexe", align: "center" },
    {
      title: "Etat",
      dataIndex: "suspension_benef",
      key: "suspension_benef",
      className: "small-cell",
      ellipsis: true,
      align: "center",
      render: (text) => {
        let tagColor, tagText;

        switch (text) {
          case "A":
            tagColor = " #46de04";
            tagText = "Actif";
            break;
          case "S":
            tagColor = "#f2b305";
            tagText = "Suspendu";
            break;
          case "R":
            tagColor = "#fa0202";
            tagText = "Résilié";
            break;
          case "W":
            tagColor = "#0570f2";
            tagText = "En cours";
            break;
          default:
            tagColor = "gray";
            tagText = "Inconnu";
        }

        return <Tag color={tagColor}>{tagText}</Tag>;
      },
    },
    {
      title: "Majorité",
      dataIndex: "codemaj",
      key: "codemaj",
      align: "center",
      render: (codemaj, record) => {
        if (record.codebenef === "3" && codemaj === "M") {
          return (
            <div style={{ display: "flex", justifyContent: "center", alignItems: "center" }}>
              <Tag color="#ff4d4f">Majeur</Tag>
            </div>
          );
        } else {
          return null; // N'affiche rien
        }
      },
      sorter: (a, b) => {
        const valueA = a.codemaj ?? "";
        const valueB = b.codemaj ?? "";
        return valueA.localeCompare(valueB);
      },
    },
    {
      title: "Durée Prog",
      dataIndex: "duree_prog",
      key: "duree_prog",
      align: "center",
    },
    {
      title: "Date Création",
      dataIndex: "datecreation",
      key: "datecreation",
      align: "center",
      render: (text) => moment(text).format("DD/MM/YYYY"),
    },
    {
      title: "Créer par",
      dataIndex: "created_by",
      key: "created_by",
      align: "center",

    },
    {
      title: (
        <div
          style={{
            backgroundColor: "#010f1c",
            color: "white",
            padding: "1px",
          }}
        ></div>
      ),
      dataIndex: "actions",
      key: "actions",
      align: "center",
      fixed: "right", // Fixe la colonne à droite
      render: (text, record) => (
        <span>
          <Tooltip title="Modifier">
            <EditOutlined
              style={{ cursor: "pointer", color: "orange", marginRight: 8 }}
              onClick={() => handleEdit(record)}
            />
          </Tooltip>

          <Popconfirm
            title="Êtes-vous sûr de vouloir supprimer cette prestation ?"
            onConfirm={() => handleDelete(record)}
            okText="Oui"
            cancelText="Non"
          >
            <Tooltip title="Supprimer">
              <DeleteFilled style={{ cursor: "pointer", color: "red" }} />
            </Tooltip>
          </Popconfirm>
        </span>
      ),
    },
  ];

  const filteredFamilleData = famille.filter((item) => item.codebenef !== "1");
  const nbrenf = filteredFamilleData.reduce(
    (sum, record) => sum + (record.codebenef === "3" ? 1 : 0),
    0
  );
  const nbrfem = filteredFamilleData.reduce(
    (sum, record) => sum + (record.codebenef === "2" ? 1 : 0),
    0
  );
  const epoux = filteredFamilleData.reduce(
    (sum, record) => sum + (record.codebenef === "4" ? 1 : 0),
    0
  );
  const handleBenef = async () => {
    try {
      const beneficiaire = await familleService.getAllBeneficiaire();
      const BenefData = beneficiaire.filter((item) => item.codetype !== "1");
      setBenefs(BenefData);
    } catch (error) { }
  };

  const calculatePosition = (codebenef) => {
    // Filtrer les bénéficiaires existants pour trouver ceux du même type
    const benefsOfSameType = filteredFamilleData.filter(
      (benef) => benef.codebenef === codebenef
    );
    let tabCodeBenef = [];

    if (benefsOfSameType.length === 0) {
      return codebenef + 1;

    } else {

      benefsOfSameType.map((item) => tabCodeBenef.push((item.matribenef).split("-")[2]));
      console.log(tabCodeBenef);
      const dernier = (Math.max(...tabCodeBenef));

      return dernier + 1;

    }

  };

  const generateMatribenef = (codebenef) => {
    const position = calculatePosition(codebenef);
    return `${matripart}-${position}`;
  };

  const handleAddAutorisationAll = async () => {

    adherentsService.updateDocAutorisesPartAll(
      typeDocuments
    ).then(() => {
      message.success("Autorisation de documents mise à jour avec succès");
      setModalVisible(false);
    })

  };

  const handleAddAutorisationAllIPM = async () => {

    adherentsService.updateDocAutorisesPartAllIPM(
      typeDocuments
    ).then(() => {
      message.success("Autorisation de documents mise à jour avec succès");
      setModalVisible(false);
    })

  };
  const handleAddAutorisation = async () => {

    adherentsService.updateDocAutorisesPartOnly(
      typeDocuments
    ).then(() => {
      message.success("Autorisation de documents mise à jour avec succès");
      setModalVisible(false);
    })


  };

  const handleBenefTypeChange = (value) => {
    setSelectedBenefType(value);

    const matribenef = generateMatribenef(value);

    const nextValues = { matribenef };

    if (value === "2") {
      nextValues.sexe = "FE";
    } else if (value === "4") {
      nextValues.sexe = "MA";
    } else {
      nextValues.sexe = undefined;
    }

    formModal.setFieldsValue(nextValues);

    // Charger la photo associée au matribenef généré
    fetchImageBeneficiare(matribenef);
  };

  const showModal = async () => {
    formModal.resetFields();
    setEditingMember(null);

    // Recharger les données des bénéficiaires avant d'ouvrir le modal
    await handleBenef();

    // Initialiser matribenef avec la valeur où codebenef égale à 1, ou générer un nouveau matribenef si nécessaire
    const initialBenefData = familleData.find((item) => item.codebenef === "1");
    if (initialBenefData) {
      formModal.setFieldsValue({
        matribenef: initialBenefData.matribenef,
      });
      // Déclencher le chargement de l'image associée à ce matribenef
      fetchImageBeneficiare(initialBenefData.matribenef);
    } else {
      // Si pas de codebenef "1", générer un nouveau matribenef pour le bénéficiaire
      const defaultCodeBenef = "1"; // Par exemple, vous pouvez ajuster ce code par défaut
      const matribenef = generateMatribenef(defaultCodeBenef);
      formModal.setFieldsValue({
        matribenef,
      });
      // Déclencher le chargement de l'image associée au matribenef généré
      fetchImageBeneficiare(matribenef);
    }

    setIsModalVisible(true);
  };

  const handleEdit = async (record) => {
    try {
      const beneficiaire = await familleService.getAllBeneficiaire();
      setBenefs(beneficiaire);

      const recordWithDate = {
        ...record,
        datenaiss: record.datenaiss
          ? dayjs(record.datenaiss, "YYYY-MM-DD")
          : null,
        date_mariage: record.date_mariage
          ? dayjs(record.date_mariage, "YYYY-MM-DD")
          : null,
        photo: record.photo,
      };

      setEditingMember(recordWithDate);
      formModal.setFieldsValue(recordWithDate);
      setSelectedBenefType(record.codebenef);

      // Déclencher le chargement de l'image associée au matribenef
      fetchImageBeneficiare(record.matribenef);

      if (record.photo) {
        setFileList([
          {
            originFileObj: null,
            url: record.photo,
          },
        ]);
      } else {
        setFileList([]);
      }

      setIsModalVisible(true);
    } catch (error) {
      console.error(
        "Erreur lors de la récupération des bénéficiaires :",
        error
      );
    }
  };

  const handleCancel = () => {
    setIsModalVisible(false);
    setEditingMember(null);
    setSelectedBenefType(null);
    formModal.resetFields();
  };

  const handleModalSubmit = () => {
    formModal
      .validateFields()
      .then(async (values) => {
        const payload = {
          ...values,
          anc_matribenef: editingMember ? editingMember.matribenef : "",
          lienjuridique: "CJ",
          matripart: matripart,
          user_id: userId,
          suspension_benef: values.suspension_benef || "A", // Valeur par défaut si non spécifiée
        };

        try {
          // Si un fichier photo est sélectionné
          if (fileList.length > 0) {
            const formData = new FormData();
            formData.append("file", fileList[0].originFileObj);
            payload.photo = formData; // Ajoutez la photo au payload
          }

          // Mise à jour ou ajout du bénéficiaire
          if (editingMember) {
            await familleService.updateBenef(payload);
            message.success("Bénéficiaire mis à jour avec succès");
          } else {
            await familleService.addBenef(payload);
            message.success("Bénéficiaire ajouté avec succès");
          }

          // Récupérer les données mises à jour de la famille
          const updatedFamilleData = await familleService.getAllBeneciaire(
            matripart
          );

          // Charger les images pour chaque bénéficiaire, y compris les nouvelles photos
          const updatedFamilleDataWithImages = await Promise.all(
            updatedFamilleData.map(async (benef) => {
              const photoUrl = await participantsIpmService.fetchImageBenef(
                benef.matribenef
              );
              return { ...benef, photoUrl };
            })
          );

          // Mettre à jour les données dans l'état, y compris les photos
          setFamilleData(updatedFamilleDataWithImages);
        } catch (error) {
          message.error("Erreur lors de la sauvegarde du bénéficiaire");
        }

        handleCancel(); // Fermer le modal
      })
      .catch((error) => {
        console.error("Erreur de validation :", error);
        message.error("Veuillez vérifier les champs du formulaire");
      });
  };

  const requiredRule = {
    required: true,
    message: "Ce champ est obligatoire",
  };

  const numficheRule = {
    required: api_DisplayName === "ipmposte",
    message: "Ce champ est obligatoire",
  };
  const phoneNumberValidator = (rule, value) => {
    const phoneNumberPattern = /^\d{2} \d{3} \d{2} \d{2}$/;
    if (!value || phoneNumberPattern.test(value)) {
      return Promise.resolve();
    }
    return Promise.reject(
      "Le numéro de téléphone doit contenir 9 chiffres au format XX XXX XX XX."
    );
  };

  const formatPhoneNumber = (value) => {
    const cleanedValue = value.replace(/\D/g, "");
    const match = cleanedValue.match(/(\d{2})(\d{3})(\d{2})(\d{2})/);
    if (match) {
      return `${match[1]} ${match[2]} ${match[3]} ${match[4]}`;
    }
    return value;
  };

  const handlePhoneNumberChange = (e) => {
    const { value } = e.target;
    formMain.setFieldsValue({
      portable: formatPhoneNumber(value),
    });
  };
  return (
    <>
      <Form form={formMain} onFinish={handleSubmit} onFinishFailed={handleFailedSubmit} layout="vertical">
        <Row gutter={16}>
          <Col span={16}>
            <Card
              style={{
                borderRadius: 12,
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                marginBottom: 16,
                border: "1px solid #f0f0f0",
              }}
              headStyle={{
                background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                borderRadius: "12px 12px 0 0",
                color: "white",
              }}
              title={
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <IdcardOutlined style={{ fontSize: 18, color: "white" }} />
                  <span style={{ fontWeight: 600, fontSize: 15, color: "white" }}>Informations Générales</span>
                </div>
              }
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Société</span>}
                    name="codesoc"
                    rules={[requiredRule]}
                  >
                    <Select
                      showSearch
                      placeholder="Sélectionner une société"
                      style={{ borderRadius: 6 }}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                      disabled={!mode}
                    >
                      {societes.map((societe) => (
                        <Option key={societe.codeadht} value={societe.codeadht}>
                          {`${societe.codeadht} - ${societe.intitule}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>

                <Col span={12}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Pays (Nationalité)</span>}
                    name="pays"
                    initialValue="SEN"
                    rules={[requiredRule]}
                  >
                    <Select
                      showSearch
                      placeholder="Sélectionner un pays"
                      style={{ borderRadius: 6 }}
                      filterOption={(input, option) =>
                        option.children
                          .toLowerCase()
                          .indexOf(input.toLowerCase()) >= 0
                      }
                    >
                      {pays.map((option) => (
                        <Option key={option.alpha3} value={option.alpha3}>
                          {`${option.alpha3} ${option.nom_fr_fr}`}
                        </Option>
                      ))}
                    </Select>
                  </Form.Item>
                </Col>
              </Row>

              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Type de pièce</span>}
                    rules={[requiredRule]}
                    name="type_piece"
                  >
                    <Select
                      style={{ width: "100%", borderRadius: 6 }}
                      placeholder="Sélectionner"
                      onChange={handleTypePieceChange}
                    >
                      <Option value="p1">CIN</Option>
                      <Option value="p2">Passport</Option>
                      <Option value="p3">Carte de séjour</Option>
                      <Option value="p4">Permis de conduire</Option>
                      <Option value="p5">Autre</Option>
                    </Select>
                  </Form.Item>
                </Col>

                {selectedTypePiece !== "p0" && (
                  <Col span={8}>
                    <Form.Item
                      label={<span style={{ fontWeight: 500 }}>{`N° ${typePieceChampsMapping[selectedTypePiece]}`}</span>}
                      name="cin"
                      rules={[requiredRule]}
                    >
                      <Input placeholder={`N° ${typePieceChampsMapping[selectedTypePiece]}`} style={{ borderRadius: 6 }} />
                    </Form.Item>
                  </Col>
                )}
                <Col span={8}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Matricule</span>}
                    name="matricule"
                    rules={[
                      requiredRule,
                      {
                        pattern: /^[^/@#%$]*$/,
                        message: "Le matricule ne peut pas contenir les caractères suivants: / @ # % $",
                      },
                    ]}
                  >
                    <Input placeholder="Matricule" style={{ borderRadius: 6 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item label={<span style={{ fontWeight: 500 }}>N.I.N.U</span>} name="ninu">
                    <Input style={{ width: "100%", borderRadius: 6 }} placeholder="N.I.N.U" />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label={<span style={{ fontWeight: 500 }}>Sexe</span>} name="sexe" rules={[requiredRule]}>
                    <Radio.Group>
                      <Radio value="FE">Femme</Radio>
                      <Radio value="MA">Homme</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label={<span style={{ fontWeight: 500 }}>Prénom</span>} name="prenom" rules={[requiredRule]}>
                    <Input placeholder="Prénom" style={{ borderRadius: 6 }} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label={<span style={{ fontWeight: 500 }}>Nom</span>} name="nom" rules={[requiredRule]}>
                    <Input placeholder="Nom" style={{ borderRadius: 6 }} />
                  </Form.Item>
                </Col>
              </Row>
              {!mode && (
                <Row gutter={16} style={{ background: "#f9f9f9", padding: "12px", borderRadius: 8, marginBottom: 8 }}>
                  <Col span={8}>
                    <Form.Item
                      label={<span style={{ fontWeight: 500 }}>Durée de propagation retraite</span>}
                      name="duree_prog_retraite"
                    >
                      <InputNumber style={{ width: "100%", borderRadius: 6 }} placeholder="Durée" />
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      label={<span style={{ fontWeight: 500 }}>Assuré?</span>}
                      name="assure"
                      valuePropName="checked"
                    >
                      <Checkbox />
                    </Form.Item>
                  </Col>

                  <Col span={8}>
                    <Form.Item
                      label={<span style={{ fontWeight: 500 }}>Calcul direct Assurance ?</span>}
                      name="calcul_direct_assur"
                      valuePropName="checked"
                    >
                      <Checkbox />
                    </Form.Item>
                  </Col>
                </Row>
              )}

              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Situation Familiale</span>}
                    name="sitfam"
                    rules={[requiredRule]}
                  >
                    <Select placeholder="Sélectionner" style={{ borderRadius: 6 }}>
                      <Option value="C">Célibataire</Option>
                      <Option value="M">Marié(e)</Option>
                      <Option value="D">Divorcé(e)</Option>
                      <Option value="V">Veuf(ve)</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Date Naissance</span>}
                    name="datenaiss"
                    rules={[requiredRule]}
                  >
                    <DatePicker
                      style={{ width: "100%", borderRadius: 6 }}
                      format="DD/MM/YYYY"
                      placeholder="JJ/MM/AAAA"
                      disabledDate={(current) => current && current > dayjs().endOf('day')}
                    />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Lieu Naissance</span>}
                    name="lieunaiss"
                    rules={[requiredRule]}
                  >
                    <Input placeholder="Lieu de naissance" style={{ borderRadius: 6 }} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Date Embauche</span>}
                    name="dateemb"
                    rules={[requiredRule]}
                  >
                    <DatePicker
                      style={{ width: "100%", borderRadius: 6 }}
                      format="DD/MM/YYYY"
                      placeholder="JJ/MM/AAAA"
                      disabledDate={(current) => current && current > dayjs().endOf('day')}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16} style={{ background: "#f5f9ff", padding: "12px", borderRadius: 8 }}>
                <Col span={8}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Taux Exceptionnel</span>}
                    name="taux_excep"
                    valuePropName="checked"
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Valeur du Taux Exceptionnel</span>}
                    name="valeur_taux_excep"
                    initialValue="0"
                  >
                    <InputNumber style={{ width: "100%", borderRadius: 6 }} />
                  </Form.Item>
                </Col>

                <Col span={8}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Plafond Exceptionnel</span>}
                    name="plafond_excep"
                    initialValue="0"
                  >
                    <InputNumber style={{ width: "100%", borderRadius: 6 }} />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Col>

          <Col span={8}>
            {!mode && (
              <Card
                style={{
                  borderRadius: 12,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  marginBottom: 16,
                  border: "1px solid #f0f0f0",
                }}
                headStyle={{
                  background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                  borderRadius: "12px 12px 0 0",
                  color: "white",
                }}
                title={
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <BankOutlined style={{ fontSize: 16, color: "white" }} />
                    <span style={{ fontWeight: 600, fontSize: 14, color: "white" }}>Transfert</span>
                  </div>
                }
                size="small"
              >
                <Form.Item
                  label={<span style={{ fontWeight: 500, fontSize: 13 }}>Basculer vers une autre société</span>}
                  style={{ marginBottom: 0 }}
                >
                  <Select
                    showSearch
                    onChange={handleSocieteChange}
                    filterOption={(input, option) =>
                      option.children.toLowerCase().includes(input.toLowerCase())
                    }
                    style={{ width: "100%", borderRadius: 6 }}
                    placeholder="Sélectionner une société"
                    value={basculerVers}
                    allowClear
                  >
                    {societes
                      .filter((societe) => societe.codeadht !== formMain.getFieldValue("codesoc"))
                      .map((societe) => (
                        <Select.Option key={societe.codeadht} value={societe.codeadht}>
                          {`${societe.codeadht} - ${societe.intitule}`}
                        </Select.Option>
                      ))}
                  </Select>
                </Form.Item>
              </Card>
            )}

            <Card
              style={{
                borderRadius: 12,
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                marginBottom: 16,
                border: "1px solid #f0f0f0",
              }}
              headStyle={{
                background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                borderRadius: "12px 12px 0 0",
                color: "white",
              }}
              title={
                <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                  <CameraOutlined style={{ fontSize: 16, color: "white" }} />
                  <span style={{ fontWeight: 600, fontSize: 14, color: "white" }}>Photo & QR Code</span>
                </div>
              }
              size="small"
            >
              <Form.Item name="photo" style={{ marginBottom: 0 }}>
                <div style={{ width: "100%", padding: 16, background: "#fafafa", borderRadius: 8 }}>
                  <div style={{ display: "flex", justifyContent: "flex-start", alignItems: "flex-start", gap: 16, marginBottom: 16 }}>
                    <div style={{
                      width: 180,
                      height: 180,
                      borderRadius: 12,
                      overflow: "hidden",
                      border: "3px solid #e8e8e8",
                      background: "#fff",
                      boxShadow: "0 4px 12px rgba(0,0,0,0.1)",
                      flexShrink: 0,
                    }}>
                      <Image
                        src={img || defaultAvatar}
                        fallback={defaultAvatar}
                        alt="avatar"
                        preview
                        style={{
                          width: 180,
                          height: 180,
                          objectFit: "cover",
                          display: "block",
                        }}
                      />
                    </div>

                    <div style={{
                      width: 150,
                      height: 150,
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      borderRadius: 8,
                      border: "2px solid #e8e8e8",
                      background: "#fff",
                      boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                      padding: 8,
                      flexShrink: 0,
                    }}>
                      <QRCode
                        value={`${matripart}`}
                        size={130}
                      />
                    </div>
                  </div>
                  {!mode && (
                    <Button
                      type="primary"
                      icon={<CameraOutlined />}
                      onClick={openModal}
                      style={{
                        background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                        border: "none",
                        borderRadius: 6,
                        fontWeight: 500,
                        boxShadow: "0 2px 8px rgba(24, 144, 255, 0.3)",
                        width: "auto",
                        padding: "0 24px",
                      }}
                    >
                      Changer la photo
                    </Button>
                  )}
                </div>
              </Form.Item>
            </Card>

            {!mode && (
              <Card
                style={{
                  borderRadius: 12,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  marginBottom: 16,
                  border: "1px solid #f0f0f0",
                }}
                headStyle={{
                  background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                  borderRadius: "12px 12px 0 0",
                  color: "white",
                }}
                title={
                  <div style={{ display: "flex", alignItems: "center", gap: 8 }}>
                    <UserOutlined style={{ fontSize: 16, color: "white" }} />
                    <span style={{ fontWeight: 600, fontSize: 14, color: "white" }}>Statut du Participant</span>
                  </div>
                }
                size="small"
              >
                <Form.Item label={<span style={{ fontWeight: 500 }}>État</span>} name="suspension_part">
                  <Radio.Group onChange={handleSuspensionChange} style={{ display: "flex", gap: 8, flexWrap: "wrap" }}>
                    <Radio.Button
                      value="W"
                      style={{
                        background: suspensionPart === "W" ? "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)"
                          : "white",
                        color: suspensionPart === "W" ? "white" : "#1890ff",
                        border: suspensionPart === "W" ? "none" : "1px solid #1890ff",
                        borderRadius: 20,
                        fontWeight: 500,
                        padding: "0 16px",
                        boxShadow: suspensionPart === "W" ? "0 2px 8px rgba(24, 144, 255, 0.3)"
                          : "none",
                      }}
                    >
                      <ClockCircleOutlined /> En attente
                    </Radio.Button>
                    <Radio.Button
                      value="A"
                      style={{
                        background: suspensionPart === "A" ? "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)"
                          : "white",
                        color: suspensionPart === "A" ? "white" : "#11998e",
                        border: suspensionPart === "A" ? "none" : "1px solid #11998e",
                        borderRadius: 20,
                        fontWeight: 500,
                        padding: "0 16px",
                        boxShadow: suspensionPart === "A" ? "0 2px 8px rgba(17, 153, 142, 0.3)"
                          : "none",
                      }}
                    >
                      <CheckCircleOutlined /> Actif
                    </Radio.Button>
                    <Radio.Button
                      value="S"
                      style={{
                        background: suspensionPart === "S" ? "linear-gradient(135deg, #f2b305 0%, #f9ce1d 100%)"
                          : "white",
                        color: suspensionPart === "S" ? "white" : "#f2b305",
                        border: suspensionPart === "S" ? "none" : "1px solid #f2b305",
                        borderRadius: 20,
                        fontWeight: 500,
                        padding: "0 16px",
                        boxShadow: suspensionPart === "S" ? "0 2px 8px rgba(242, 179, 5, 0.3)"
                          : "none",
                      }}
                    >
                      <StopOutlined /> Suspendu
                    </Radio.Button>
                    <Radio.Button
                      value="R"
                      style={{
                        background: suspensionPart === "R" ? "linear-gradient(135deg, #fa0202 0%, #ff4d4d 100%)"
                          : "white",
                        color: suspensionPart === "R" ? "white" : "#fa0202",
                        border: suspensionPart === "R" ? "none" : "1px solid #fa0202",
                        borderRadius: 20,
                        fontWeight: 500,
                        padding: "0 16px",
                        boxShadow: suspensionPart === "R" ? "0 2px 8px rgba(250, 2, 2, 0.3)"
                          : "none",
                      }}
                    >
                      <CloseCircleOutlined /> Résilié
                    </Radio.Button>
                  </Radio.Group>
                </Form.Item>

                {(suspensionPart === "S" || suspensionPart === "R") && (
                  <>
                    <Form.Item label={<span style={{ fontWeight: 500 }}>Motif</span>} name="motif_suspension">
                      <Select style={{ width: "100%", borderRadius: 6 }} placeholder="Sélectionner un motif">
                        {suspensionPart === "S" && (
                          <>
                            <Select.Option value="depassement">Dépassement</Select.Option>
                            <Select.Option value="attente">Attente</Select.Option>
                            <Select.Option value="delai_expire">Délai Prise en Charge Expiré</Select.Option>
                            <Select.Option value="indisponibilite">Indisponibilité</Select.Option>
                            <Select.Option value="temporaire">Temporaire</Select.Option>
                          </>
                        )}
                        {suspensionPart === "R" && (
                          <>
                            <Select.Option value="retraite">Retraite</Select.Option>
                            <Select.Option value="deces">Décès</Select.Option>
                            <Select.Option value="demission">Démission</Select.Option>
                            <Select.Option value="licenciement">Licenciement</Select.Option>
                          </>
                        )}
                      </Select>
                    </Form.Item>
                    {(motifSuspensionValue === "indisponibilite" || motifSuspensionValue === "temporaire") && (
                      <>
                        <Row gutter={16}>
                          <Col span={12}>
                            <Form.Item
                              label={<span style={{ fontWeight: 500 }}>Date de début Suspension</span>}
                              name="date_deb_suspension"
                            >
                              <DatePicker
                                style={{ width: "100%", borderRadius: 6 }}
                                format="DD/MM/YYYY"
                              />
                            </Form.Item>
                          </Col>
                          <Col span={12}>
                            <Form.Item
                              label={<span style={{ fontWeight: 500 }}>Durée de la Suspension (mois)</span>}
                              name="duree_suspension"
                            >
                              <InputNumber min={1} style={{ width: "100%", borderRadius: 6 }} />
                            </Form.Item>
                          </Col>
                        </Row>
                        <Row gutter={16}>
                          <Col span={24}>
                            <Form.Item
                              label={<span style={{ fontWeight: 500 }}>Description</span>}
                              name="desc_suspension"
                            >
                              <Input.TextArea rows={3} style={{ borderRadius: 6 }} />
                            </Form.Item>
                          </Col>
                        </Row>
                      </>
                    )}
                  </>
                )}
              </Card>
            )}
          </Col>
        </Row>
        <Tabs
          defaultActiveKey="1"
          size="middle"
          tabBarGutter={16}
          tabPosition="top"
          style={{
            marginTop: 16,
          }}
          tabBarStyle={{
            fontWeight: 600,
            fontSize: 14,
          }}
        >
          {!mode && (
            <Tabs.TabPane
              tab={
                <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <TeamOutlined />
                  <strong>Ayants droits</strong>
                </span>
              }
              key="1"
            >
              <Card
                style={{
                  borderRadius: 12,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  border: "1px solid #f0f0f0",
                }}
                headStyle={{
                  background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                  borderRadius: "12px 12px 0 0",
                  color: "white",
                }}
                title={
                  <div style={{ display: "flex", gap: 16, flexWrap: "wrap" }}>
                    <span style={{
                      background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                      color: "white",
                      padding: "4px 12px",
                      borderRadius: 12,
                      fontSize: 13,
                      fontWeight: 500,
                    }}>
                      Age: {initialValues.agepart}
                    </span>
                    <span style={{
                      background: "linear-gradient(135deg, #eb3349 0%, #f45c43 100%)",
                      color: "white",
                      padding: "4px 12px",
                      borderRadius: 12,
                      fontSize: 13,
                      fontWeight: 500,
                    }}>
                      Epoux(se): {nbrfem > 0 ? nbrfem : epoux}
                    </span>
                    <span style={{
                      background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
                      color: "white",
                      padding: "4px 12px",
                      borderRadius: 12,
                      fontSize: 13,
                      fontWeight: 500,
                    }}>
                      Enfants: {nbrenf}
                    </span>
                  </div>
                }
                extra={
                  <Button
                    type="primary"
                    icon={<PlusOutlined />}
                    onClick={showModal}
                    style={{
                      background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                      border: "none",
                      borderRadius: 6,
                      fontWeight: 500,
                      boxShadow: "0 2px 8px rgba(24, 144, 255, 0.3)",
                    }}
                  >
                    Ajouter un membre
                  </Button>
                }
              >
                <Table
                  dataSource={filteredFamilleData}
                  columns={columns}
                  showSorterTooltip={false}
                  scroll={{ x: true }}
                  style={{
                    cursor: "pointer",
                    whiteSpace: "nowrap",
                    width: "100%",
                  }}
                  className="custom-header2-table my-custom-table"
                  bordered
                  pagination={{
                    pageSize: 5, // le nombre d'éléments par page
                  }}
                />
              </Card>
            </Tabs.TabPane>
          )}
          <Tabs.TabPane
            tab={
              <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <EnvironmentOutlined />
                <strong>Coordonnées</strong>
              </span>
            }
            forceRender
            key="2"
          >
            <Card
              style={{
                borderRadius: 12,
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                border: "1px solid #f0f0f0",
              }}
            >
              <Row gutter={16}>
                <Col span={12}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Adresse</span>}
                    name="adresse"
                    rules={[requiredRule]}
                  >
                    <Input placeholder="Adresse complète" style={{ borderRadius: 6 }} />
                  </Form.Item>
                </Col>
                <Col span={12}>
                  <Form.Item label={<span style={{ fontWeight: 500 }}>Email</span>} name="email" rules={[requiredRule]}>
                    <Input placeholder="email@exemple.com" style={{ borderRadius: 6 }} type="email" />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Région</span>}
                    initialValue={"Dakar"}
                    name="region"
                    rules={[requiredRule]}
                  >
                    <Region />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label={<span style={{ fontWeight: 500 }}>Département</span>} name="departement">
                    <DepartementSelect />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Portable</span>}
                    name="portable"
                    rules={[requiredRule]}
                  >
                    <Input
                      addonBefore="+221"
                      placeholder="XX XXX XX XX"
                      onChange={handlePhoneNumberChange}
                      style={{ borderRadius: 6 }}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={
              <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <IdcardOutlined />
                <strong>Infos Professionnelles</strong>
              </span>
            }
            key="3"
          >
            <Card
              style={{
                borderRadius: 12,
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                border: "1px solid #f0f0f0",
              }}
            >
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Numéro Fiche Employé</span>}
                    name="numfiche"
                    rules={[numficheRule]}
                  >
                    <Input placeholder="N° Fiche" style={{ borderRadius: 6 }} />
                  </Form.Item>
                </Col>
                <Col span={4}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Type Contrat</span>}
                    name="typecontrat"
                    initialValue="CDI"
                    rules={[requiredRule]}
                  >
                    <Radio.Group>
                      <Radio value="CDD">CDD</Radio>
                      <Radio value="CDI">CDI</Radio>
                    </Radio.Group>
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label={<span style={{ fontWeight: 500 }}>Catégorie</span>} name="categprof">
                    <Input placeholder="Catégorie" style={{ borderRadius: 6 }} />
                  </Form.Item>
                </Col>
                <Col span={6}>
                  <Form.Item label={<span style={{ fontWeight: 500 }}>Emploi</span>} name="emploi">
                    <Input placeholder="Emploi" style={{ borderRadius: 6 }} />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item label={<span style={{ fontWeight: 500 }}>Direction</span>} name="codedir">
                    <CategoriesPro
                      type="DIR"
                      onChange={(value) =>
                        form.setFieldsValue({ codedir: value })
                      }
                      value={form.getFieldValue("codedir")}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label={<span style={{ fontWeight: 500 }}>Département</span>} name="codedept">
                    <CategoriesPro
                      type="DEPT"
                      onChange={(value) =>
                        form.setFieldsValue({ codedept: value })
                      }
                      value={form.getFieldValue("codedept")}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label={<span style={{ fontWeight: 500 }}>Service</span>} name="codeserv">
                    <CategoriesPro
                      type="SRV"
                      onChange={(value) =>
                        form.setFieldsValue({ codeserv: value })
                      }
                      value={form.getFieldValue("codeserv")}
                    />
                  </Form.Item>
                </Col>
              </Row>
            </Card>
          </Tabs.TabPane>
          <Tabs.TabPane
            tab={
              <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                <FileTextOutlined />
                <strong>Infos Contrat IPM</strong>
              </span>
            }
            key="4"
          >
            <Card
              style={{
                borderRadius: 12,
                boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                border: "1px solid #f0f0f0",
              }}
            >
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item label={<span style={{ fontWeight: 500 }}>Numéro Fiche</span>} name="numfiche">
                    <Input placeholder="N° Fiche" style={{ borderRadius: 6 }} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label={<span style={{ fontWeight: 500 }}>Numéro Contrat</span>} name="numcontrat">
                    <Input placeholder="N° Contrat" style={{ borderRadius: 6 }} />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label={<span style={{ fontWeight: 500 }}>Date Souscription</span>} name="datesous">
                    <DatePicker
                      style={{ width: "100%", borderRadius: 6 }}
                      format="DD/MM/YYYY"
                      placeholder="JJ/MM/AAAA"
                      disabledDate={(current) => current && current > dayjs().endOf('day')}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={8}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>État Contrat</span>}
                    name="etatcont"
                    initialValue="OU"
                  >
                    <Select onChange={handleEtatContChange} style={{ borderRadius: 6 }} placeholder="Sélectionner">
                      <Option value="OU">Ouverture</Option>
                      <Option value="FE">Fermeture</Option>
                      <Option value="RA">Radiation</Option>
                    </Select>
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label={<span style={{ fontWeight: 500 }}>Date Résiliation</span>} name="dateres">
                    <DatePicker
                      style={{ width: "100%", borderRadius: 6 }}
                      format="DD/MM/YYYY"
                      placeholder="JJ/MM/AAAA"
                      disabledDate={(current) => current && current > dayjs().endOf('day')}
                    />
                  </Form.Item>
                </Col>
                <Col span={8}>
                  <Form.Item label={<span style={{ fontWeight: 500 }}>Date Radiation</span>} name="dateradiation">
                    <DatePicker
                      style={{ width: "100%", borderRadius: 6 }}
                      format="DD/MM/YYYY"
                      placeholder="JJ/MM/AAAA"
                      disabledDate={(current) => current && current > dayjs().endOf('day')}
                    />
                  </Form.Item>
                </Col>
              </Row>
              <Row gutter={16}>
                <Col span={6}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Prise en Charge Temporaire</span>}
                    name="pc_temporaire"
                    valuePropName="checked"
                    initialValue={false}
                  >
                    <Checkbox />
                  </Form.Item>
                </Col>
                <Col span={6} style={{ display: pcTemporaireContratValue ? "block" : "none" }}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Date de début</span>}
                    name="date_deb_couverture"
                    initialValue={dayjs()}
                  >
                    <DatePicker
                      style={{ width: "100%", borderRadius: 6 }}
                      format="DD/MM/YYYY"
                    />
                  </Form.Item>
                </Col>
                <Col span={6} style={{ display: pcTemporaireContratValue ? "block" : "none" }}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Nombre de mois couvert</span>}
                    name="nb_mois_couvert"
                    initialValue={1}
                  >
                    <InputNumber min={1} style={{ width: "100%", borderRadius: 6 }} />
                  </Form.Item>
                </Col>
                <Col span={6} style={{ display: pcTemporaireContratValue ? "block" : "none" }}>
                  <Form.Item
                    label={<span style={{ fontWeight: 500 }}>Date de Fin de Couverture</span>}
                    name="date_fin_couverture"
                  >
                    <DatePicker
                      className="readonly-highlight"
                      style={{ width: "100%", borderRadius: 6 }}
                      format="DD/MM/YYYY"
                      disabled
                    />
                  </Form.Item>
                </Col>
              </Row>

            </Card>
          </Tabs.TabPane>
          {mode !== "add" &&
            <Tabs.TabPane
              tab={
                <span style={{ display: "flex", alignItems: "center", gap: 6 }}>
                  <CheckCircleOutlined />
                  <strong>Documents Autorisés</strong>
                </span>
              }
              key="5"
            >
              <Card
                style={{
                  borderRadius: 12,
                  boxShadow: "0 2px 8px rgba(0,0,0,0.08)",
                  border: "1px solid #f0f0f0",
                }}
              >
                <Row gutter={16}>
                  <Col span={12}>
                    <Table
                      columns={columnsDoc}
                      dataSource={typeDocuments}
                      size="small"
                      bordered
                      pagination={false}
                      rowKey={(record) => record.typedoc}
                      style={{ marginTop: "5px", marginBottom: "20px" }}
                      scroll={{ x: true }}
                    />
                  </Col>
                  <Col span={12}>
                    <Space direction="vertical" style={{ width: "100%" }}>
                      <Button
                        type="primary"
                        block
                        onClick={handleAddAutorisation}
                        style={{
                          background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                          border: "none",
                          borderRadius: 6,
                          fontWeight: 500,
                          height: 40,
                          boxShadow: "0 2px 8px rgba(24, 144, 255, 0.3)",
                        }}
                      >
                        Valider uniquement pour ce participant
                      </Button>
                      <Button
                        block
                        onClick={handleAddAutorisationAll}
                        style={{
                          background: "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)",
                          border: "none",
                          color: "#fff",
                          borderRadius: 6,
                          fontWeight: 500,
                          height: 40,
                          boxShadow: "0 2px 8px rgba(17, 153, 142, 0.3)",
                        }}
                      >
                        Appliquer à tous les participants de : {societes.find((s) => s.codeadht === formMain.getFieldValue("codesoc"))?.intitule}
                      </Button>
                      <Button
                        block
                        onClick={handleAddAutorisationAllIPM}
                        style={{
                          background: "linear-gradient(135deg, #4a5568 0%, #718096 100%)",
                          border: "none",
                          color: "#fff",
                          borderRadius: 6,
                          fontWeight: 500,
                          height: 40,
                          boxShadow: "0 2px 8px rgba(74, 85, 104, 0.3)",
                        }}
                      >
                        Appliquer à tous les participants de l'ipm
                      </Button>
                    </Space>
                  </Col>
                </Row>
              </Card>
            </Tabs.TabPane>
          }

        </Tabs>
        <Form.Item style={{ marginTop: 24, marginBottom: 0 }}>
          <div
            style={{
              display: "flex",
              justifyContent: "flex-end",
              gap: 12,
              padding: "16px 20px",
              background: "#fafafa",
              borderRadius: 12,
              boxShadow: "0 -2px 8px rgba(0,0,0,0.05)",
              border: "1px solid #f0f0f0",
            }}
          >
            <Link to="/participants" state={{ codesocFromPart: formMain.getFieldValue("codesoc") }}>
              <Button
                icon={<CloseOutlined />}
                size="large"
                style={{
                  borderRadius: 6,
                  fontWeight: 500,
                  padding: "0 24px",
                  border: "1px solid #d9d9d9",
                }}
              >
                Annuler
              </Button>
            </Link>
            <Button
              type="primary"
              icon={<SaveOutlined />}
              htmlType="submit"
              size="large"
              style={{
                background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                border: "none",
                borderRadius: 6,
                fontWeight: 500,
                padding: "0 32px",
                boxShadow: "0 2px 8px rgba(24, 144, 255, 0.35)",
              }}
            >
              Enregistrer
            </Button>
          </div>
        </Form.Item>

        <Modal
          title={
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              {editingMember ? (
                <>
                  <EditOutlined style={{ fontSize: 20, color: "#1890ff" }} />
                  <span style={{ fontSize: 16, fontWeight: 600 }}>Modification Membre</span>
                </>
              ) : (
                <>
                  <PlusOutlined style={{ fontSize: 20, color: "#1890ff" }} />
                  <span style={{ fontSize: 16, fontWeight: 600 }}>Ajout Membre</span>
                </>
              )}
            </div>
          }
          open={isModalVisible}
          onCancel={handleCancel}
          footer={[
            <Button
              key="back"
              onClick={handleCancel}
              icon={<CloseOutlined />}
              style={{
                borderRadius: 6,
                fontWeight: 500,
              }}
            >
              Annuler
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={handleModalSubmit}
              icon={editingMember ? <SaveOutlined /> : <PlusOutlined />}
              style={{
                background: editingMember
                  ? "linear-gradient(135deg, #11998e 0%, #38ef7d 100%)"
                  : "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                border: "none",
                borderRadius: 6,
                fontWeight: 500,
                boxShadow: editingMember
                  ? "0 2px 8px rgba(17, 153, 142, 0.3)"
                  : "0 2px 8px rgba(24, 144, 255, 0.3)",
              }}
            >
              {editingMember ? "Modifier" : "Ajouter"}
            </Button>,
          ]}
          width={850}
          maskClosable={false}
        >
          <Form form={formModal} layout="vertical">
            <Row gutter={16}>
              <Col span={14}>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      label="Type de Bénéficiaire"
                      name="codebenef"
                      initialValue="Selectionner..."
                      rules={[requiredRule]}
                    >
                      <Select showSearch onChange={handleBenefTypeChange}>
                        {benefs.map((option) => (
                          <Option key={option.codetype} value={option.codetype}>
                            {` ${option.libtype}`}
                          </Option>
                        ))}
                      </Select>
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Sexe"
                      name="sexe"
                      rules={[
                        { required: true, message: "Ce champ est obligatoire" },
                      ]}
                    >
                      <Radio.Group>
                        <Radio value="MA">Homme</Radio>
                        <Radio value="FE">Femme</Radio>
                      </Radio.Group>
                    </Form.Item>
                  </Col>
                </Row>

                <Form.Item
                  label="Prénom(s)"
                  name="prenoms"
                  rules={[
                    { required: true, message: "Ce champ est obligatoire" },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item
                  label="Nom"
                  name="nom"
                  rules={[
                    { required: true, message: "Ce champ est obligatoire" },
                  ]}
                >
                  <Input />
                </Form.Item>
                <Form.Item label="Adresse" name="adresse">
                  <Input />
                </Form.Item>
                <Row gutter={16}>
                  <Col span={12}>
                    <Form.Item
                      label="Date Naissance"
                      name="datenaiss"
                      rules={[
                        { required: true, message: "Ce champ est obligatoire" },
                      ]}
                    >
                      <DatePicker
                        style={{ width: "100%" }}
                        format="DD/MM/YYYY"
                        disabledDate={(current) => current && current > dayjs().endOf('day')}
                      />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="Lieu Naissance" name="lieunaiss">
                      <Input />
                    </Form.Item>
                  </Col>
                </Row>
                <Row gutter={16}>
                  {selectedBenefType === "2" && ( // Remplacez "2" par le code correspondant pour "Epouse"
                    <Form.Item label="Date Mariage" name="date_mariage">
                      <DatePicker
                        style={{ width: "230px" }}
                        format="DD/MM/YYYY"
                        disabledDate={(current) => current && current > dayjs().endOf('day')}
                      />
                    </Form.Item>
                  )}
                  {selectedBenefType === "3" && ( // Remplacez "3" par le code correspondant pour "Enfant"
                    <Form.Item
                      label="Rang Mère"
                      name="rang_mere"
                      initialValue="1"
                    >
                      <Select showSearch style={{ width: "230px" }}>
                        <Option value="1">1</Option>
                        <Option value="2">2</Option>
                        <Option value="3">3</Option>
                        <Option value="4">4</Option>
                        <Option value="autre">Autre</Option>
                      </Select>
                    </Form.Item>
                  )}

                  <Col span={12}>
                    <Form.Item label="CIN bénéficiaire" name="cin_benef">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item
                      label="Durée Prorogation (ans)"
                      name="duree_prog"
                    >
                      <InputNumber style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                  <Col span={12}>
                    <Form.Item label="N.I.N.U" name="nuni_benef">
                      <Input style={{ width: "100%" }} />
                    </Form.Item>
                  </Col>
                </Row>
              </Col>

              <Col span={10}>
                <Form.Item
                  name="matribenef"
                  label={<span style={{ fontWeight: 500 }}>Matricule Bénéficiaire</span>}
                  style={{ marginBottom: 16 }}
                >
                  <Input
                    style={{
                      width: "100%",
                      backgroundColor: "#96fa87",
                      color: "#0e6102",
                      fontSize: "18px",
                      fontWeight: "bold",
                      textAlign: "center",
                      padding: "12px",
                      borderRadius: "6px",
                      border: "2px solid #0e6102",
                      boxShadow: "0 2px 8px rgba(150, 250, 135, 0.3)",
                    }}
                    disabled
                  />
                </Form.Item>

                <Form.Item label="Photo" name="photo">
                  <Card
                    hoverable
                    style={{ width: "100%", textAlign: "left", padding: 8 }}
                    cover={
                      <Space
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                        }}
                      >
                        <img
                          src={imgBenef || defaultAvatar}
                          onError={(e) => {
                            e.target.src = defaultAvatar; // Remplace par defaultAvatar si l'image échoue
                          }}
                          alt="avatar"
                          style={{
                            width: "100%",
                            height: 200,
                            objectFit: "contain",
                            borderRadius: "8px 8px 0 0",
                          }}
                        />

                        {formModal.getFieldValue("matribenef") ? (
                          <QRCode
                            value={formModal.getFieldValue("matribenef")}
                            // size={175}
                            style={{
                              width: "75%",
                              height: "auto",
                              objectFit: "cover",
                              borderRadius: "8px",
                            }}
                          />
                        ) : null}
                      </Space>
                    }
                  >
                    <Card.Meta
                      description={
                        <Button
                          type="primary"
                          icon={<EditOutlined />}
                          onClick={openModalBenef}
                        >
                          Changer la photo
                        </Button>
                      }
                    />
                  </Card>
                </Form.Item>

                <Form.Item name="suspension_benef">
                  <Radio.Group>
                    <Radio.Button
                      value="W"
                      style={{
                        backgroundColor:
                          suspensionBenefValue === "W" ? "blue" : "white",
                        color: suspensionBenefValue === "W" ? "white" : "blue",
                      }}
                    >
                      En attente
                    </Radio.Button>
                    <Radio.Button
                      value="A"
                      style={{
                        backgroundColor:
                          suspensionBenefValue === "A" ? "#46de04" : "white",
                        color: suspensionBenefValue === "A" ? "white" : "#46de04",
                      }}
                    >
                      Actif
                    </Radio.Button>
                    <Radio.Button
                      value="S"
                      style={{
                        backgroundColor:
                          suspensionBenefValue === "S" ? "#f2b305" : "white",
                        color: suspensionBenefValue === "S" ? "white" : "#f2b305",
                      }}
                    >
                      Suspendu
                    </Radio.Button>
                    <Radio.Button
                      value="R"
                      style={{
                        backgroundColor:
                          suspensionBenefValue === "R" ? "#fa0202" : "white",
                        color: suspensionBenefValue === "R" ? "white" : "#fa0202",
                      }}
                    >
                      Résilié
                    </Radio.Button>
                  </Radio.Group>
                </Form.Item>
              </Col>
            </Row>
          </Form>
        </Modal>

        <Modal
          title={
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <CameraOutlined style={{ fontSize: 20, color: "#1890ff" }} />
              <span style={{ fontSize: 16, fontWeight: 600 }}>Changer la photo</span>
            </div>
          }
          open={modalVisible}
          onCancel={closeModal}
          footer={[
            <Button
              key="cancel"
              onClick={closeModal}
              icon={<CloseOutlined />}
              style={{
                borderRadius: 6,
                fontWeight: 500,
              }}
            >
              Annuler
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={handleUpload}
              loading={loading}
              icon={<SaveOutlined />}
              style={{
                background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                border: "none",
                borderRadius: 6,
                fontWeight: 500,
                boxShadow: "0 2px 8px rgba(24, 144, 255, 0.3)",
              }}
            >
              Enregistrer
            </Button>,
          ]}
        >
          <Card
            hoverable
            style={{ width: 240, margin: "0 auto", textAlign: "center" }}
            cover={
              <Upload
                beforeUpload={() => false}
                fileList={fileList}
                onChange={handleUploadChange}
                accept="image/*"
                showUploadList={false}
                maxCount={1}
              >
                <div
                  style={{
                    padding: "20px",
                    border: "1px dashed #d9d9d9",
                    borderRadius: "4px",
                  }}
                >
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>
                    Sélectionner une image
                    <br />
                    (jpg, jpeg, bmp, png, gif)
                  </div>
                </div>
              </Upload>
            }
          >
            {fileList.length > 0 && (
              <img
                alt="example"
                style={{ width: "100%", marginTop: "16px" }}
                src={URL.createObjectURL(fileList[0].originFileObj)}
              />
            )}
          </Card>
        </Modal>
        <Modal
          title={
            <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
              <CameraOutlined style={{ fontSize: 20, color: "#1890ff" }} />
              <span style={{ fontSize: 16, fontWeight: 600 }}>Changer la photo du bénéficiaire</span>
            </div>
          }
          open={modalVisibleBenef}
          onCancel={closeModalBenef}
          footer={[
            <Button
              key="cancel"
              onClick={closeModalBenef}
              icon={<CloseOutlined />}
              style={{
                borderRadius: 6,
                fontWeight: 500,
              }}
            >
              Annuler
            </Button>,
            <Button
              key="submit"
              type="primary"
              onClick={handleUploadBenef}
              icon={<SaveOutlined />}
              style={{
                background: "linear-gradient(135deg, #1890ff 0%, #0097e6 100%)",
                border: "none",
                borderRadius: 6,
                fontWeight: 500,
                boxShadow: "0 2px 8px rgba(24, 144, 255, 0.3)",
              }}
            >
              Enregistrer
            </Button>,
          ]}
        >
          <Card
            hoverable
            style={{ width: 240, margin: "0 auto", textAlign: "center" }}
            cover={
              <Upload
                beforeUpload={() => false}
                fileList={fileList}
                onChange={handleUploadBenefChange}
                accept="image/*"
                showUploadList={false}
                maxCount={1}
              >
                <div
                  style={{
                    padding: "20px",
                    border: "1px dashed #d9d9d9",
                    borderRadius: "4px",
                  }}
                >
                  <PlusOutlined />
                  <div style={{ marginTop: 8 }}>
                    Sélectionner une image en <br />
                    (jpg, jpeg, bmp, png, gif)
                  </div>
                </div>
              </Upload>
            }
          >
            {fileList.length > 0 && (
              <img
                alt="example"
                style={{ width: "100%", marginTop: "16px" }}
                src={URL.createObjectURL(fileList[0].originFileObj)}
              />
            )}
          </Card>
        </Modal>
      </Form>
    </>
  );
};

export default Formulaire;
